import React from "react";
import Sprite from "./Sprite";
import { SPARKLES } from "./atlas";
import { seeded } from "../halloween/sprites";

/**
 * Pixel stars twinkling at seeded spots inside the nearest positioned parent:
 * the same seed always scatters them the same way, so they do not jump around
 * on re-render. `area` is [top%, bottom%] of the parent to scatter within.
 */
var NAMES = ["gold0", "gold1", "gold2", "gold3", "blue0", "blue1"];

export default function Twinkles({ count, seed, area }) {
  var rand = seeded(seed || 1);
  var from = area ? area[0] : 4;
  var to = area ? area[1] : 45;
  var stars = [];
  for (var i = 0; i < (count || 8); i++) {
    stars.push({
      left: (3 + rand() * 94).toFixed(1) + "%",
      top: (from + rand() * (to - from)).toFixed(1) + "%",
      name: NAMES[Math.floor(rand() * NAMES.length)],
      scale: 0.32 + rand() * 0.3,
      delay: (-rand() * 3).toFixed(2) + "s",
      duration: (2 + rand() * 2.2).toFixed(2) + "s",
    });
  }
  return (
    <span aria-hidden="true" style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, pointerEvents: "none" }}>
      {stars.map(function (star, index) {
        return (
          <Sprite
            key={index}
            atlas={SPARKLES}
            name={star.name}
            scale={star.scale}
            className="xm-twinkle"
            style={{
              position: "absolute",
              left: star.left,
              top: star.top,
              animationDelay: star.delay,
              animationDuration: star.duration,
            }}
          />
        );
      })}
    </span>
  );
}
